import * as React from "react";
import { Grid } from "@material-ui/core";
import { H3 as H3Raw } from "./Headers";
import styled from "styled-components";
import ReadDocsCard from "./cards/ReadDocsCard";
import APIDefinitionCard from "./cards/APIDefinitionCard";
import TryCodeCard from "./cards/TryCodeCard";
import ViewTicketsCard from "./cards/ViewTicketsCard";
import SMSCredentialsCard from "./cards/SMSCredentialsCard";
import RegisterCard from "./cards/RegisterCard";
import SubmitTicketsCard from "./cards/SubmitTicketsCard";
import SubmitServiceRequestCard from "./cards/SubmitServiceRequestCard";
import PartnershipTiersCard from "./cards/PartnershipTiersCard";
import PartnershipBrandingCard from "./cards/PartnershipBrandingCard";
import AuthorizedComponent from "./api-authorization/AuthorizedComponent";
import Roles from "../models/Roles";
import IntegrationDefinitionCard from "./cards/IntegrationDefinitionCard";

const H3 = styled(H3Raw)`
  margin-left: 10px;
  margin-top: 2em;

  :first-child {
    margin-top: 0;
  }
`;

export default function FeatureGrid() {
  return (
    <Grid container spacing={3}>
      <H3>Build, Connect and Create with APIs and SDKs</H3>
      <AuthorizedComponent allowUnauthorized={true} roles={[Roles.Admin, Roles.Documentation]}>
        <ReadDocsCard />
      </AuthorizedComponent>
      <APIDefinitionCard />
      <AuthorizedComponent allowUnauthorized={true} roles={[Roles.Admin, Roles.Documentation]}>
        <TryCodeCard />
      </AuthorizedComponent>
      <IntegrationDefinitionCard />
      <AuthorizedComponent allowUnauthorized={true} roles={[Roles.Admin, Roles.Support]}>
        <H3>Manage your Support Tickets</H3>
        <SubmitTicketsCard />
        <SubmitServiceRequestCard />
        <ViewTicketsCard />
      </AuthorizedComponent>
      <SMSCredentialsCard />
      <H3>Your Partnership is Important</H3>
      <RegisterCard />
      <PartnershipTiersCard />
      <PartnershipBrandingCard />
    </Grid>
  );
}
